import { render } from "./holdings.vue?vue&type=template&id=462fe98e"
import script from "./holdings.vue?vue&type=script&lang=js"
export * from "./holdings.vue?vue&type=script&lang=js"

import "./holdings.vue?vue&type=style&index=0&id=462fe98e&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__